import { css } from "../../../component-styles";

/** No spacing overrides — inherits from the page's global CSS. */
export const none = css``;
